export default "__VITE_ASSET__85709539__"